import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { ScrollView, View,  } from '@dbk/ui-react-utils';
import { NavigationList, NavigationListItem, NavigationListItemHeader, NavigationListItemFooter, NavigationListItemContent } from '@dbk/ui-list';
import Badge from '@dbk/ui-badge';
import { TouchableOpacity, StyleSheet } from 'react-native';
import { createContainer } from '@dbk-legacy/muster/react';
import { SELECTED_RANGE, REPORT_CATEGORY  } from '../constants';
import { LoadingCircle } from '../../../../../../src/components/common/loading';
import { PALETTE, EBANKINGWEBLUX, EBANKINGWEB } from '../../../constants';
import envConfig from '../../../../../../db-env-build';
import { RM_REGION, RM_REGION_CH, REPORTS } from '../../../../../../src/constants';
import { Tab, Tabs } from '@dbk/ui-tabs';
import { Text } from 'react-native';
import Grid, { Cell } from '@dbk/ui-grid';
import { Checkbox } from '@dbk/ui-forms';
import {Visible, DownloadIcon, CardMenu} from '@dbk/ui-icons';
import OutsideClickNotifier from './outside-click-notifier';



class ReportStatement extends PureComponent {

  constructor(props) {
    super(props);
    this.state = {
      selectedItem: 0,
      detailModel: true,
      loadingRow: null,
      showMoreTabs: false,
      isHoveredOnCardMenu: false,
    };

  }

  /**
   * function: onRowClick will be called from Navigation List item.
   * It will route the screen to detail view of category list.
   */
  // onRowClick = (index, docCategoryId, docCategoryName) => {    //to be deleted
  //   this.setState({ selectedItem: index });
  //   this.props.setSelectedCategoryId(docCategoryId, docCategoryName);
  // }

  componentWillMount() {

    // load intital tab
    const {reports: {selectedCategoryTabIndex}} = this.props
    this.handleSelectedIndex(selectedCategoryTabIndex ? selectedCategoryTabIndex : 0, this.rangeCategoryList())

  }

  /**
   * function: componentWillMount will be used to load the documents
  componentWillMount() {
    this.props.getDocuments();
  }
   */
  

  handleSelectedIndex = (index, categoryList) => {
    if(index <= REPORTS.VARIABLE_TAB_INDEX ){
      this.props.setSelectedCategoryId(categoryList[index].docCategoryId, categoryList[index].docCategoryName);
    }
    this.props.reports.setSelectedCategoryTabIndex(index);
  }

  setRangeCategoryList = (categoryList) => {
    const { reports: { statement : { setLastWeek, setLastMonth, setlast90days, setCustomRangeList } , selectedReportDetailsDateRange } } = this.props;
    switch(selectedReportDetailsDateRange) {
      case SELECTED_RANGE.LAST_WEEK:
        setLastWeek(categoryList);
        break;
      case SELECTED_RANGE.LAST_MONTH:
        setLastMonth(categoryList);
        break;
      case SELECTED_RANGE.last90days:
        setlast90days(categoryList);
        break;
      case SELECTED_RANGE.CUSTOM:
        setCustomRangeList(categoryList);
        break;
      default:
        
    }
    return categoryList;
  }

  variableTabsHandler = (rowIndex, categoryList) => {
    const { reports: { swapCategories } } = this.props;
    swapCategories(rowIndex , categoryList);
    this.setState({
      ...this.state, showMoreTabs: false
    })
  }

  renderCell = ({ rowIndex}) => {
    const categoryList = this.rangeCategoryList();
    return (
      <Cell  onClick = { () => this.variableTabsHandler(rowIndex, categoryList) }>
        <View className='category-tabs__tab--cell_view'>
        <View className='category-tabs__tab--cell_view--cell_text'><Text>{categoryList[rowIndex + REPORTS.NUMBAR_OF_FIXED_TABS].docCategoryName}</Text></View>
         <View >
         {categoryList[rowIndex + REPORTS.NUMBAR_OF_FIXED_TABS].docCategoryName != REPORT_CATEGORY.ALL_DOCUMENTS && <Badge value={categoryList[rowIndex + REPORTS.NUMBAR_OF_FIXED_TABS].countOfUnreadDocs}/>}
         </View>
        </View>
      </Cell>
    )
  }

  columnWidth() {
    return '100%';
  }

  renderCategoryTab = (item) => {
    return (
      <Tab 
        renderLabel={ () => 
          <View className='category-tabs__tab'>
            <Text className="category-tabs__tab--text">{item.docCategoryName}</Text>
            <Badge value={item.countOfUnreadDocs}/>
          </View>
        }
      />
    )
  }

  rangeCategoryList = () => {
    const { i18n: { messages }, reports: { statement : { lastWeek, lastMonth, last90days, customRangeList } , selectedReportDetailsDateRange } } = this.props;
    let categoryList = [];
    switch(selectedReportDetailsDateRange) {
      case SELECTED_RANGE.LAST_WEEK:
        categoryList = lastWeek;
        break;
      case SELECTED_RANGE.LAST_MONTH:
        categoryList = lastMonth;
        break;
      case SELECTED_RANGE.LAST_90_DAYS:
        categoryList = last90days;
        break;
      case SELECTED_RANGE.CUSTOM:               // TODO:  Revisit this condition again
        categoryList = customRangeList;
        // categoryList = (customRangeList && customRangeList.length > 0) ? customRangeList : 
        // (envConfig.envConfig === EBANKINGWEBLUX || envConfig.rmRegion === RM_REGION) ? JSON.parse(messages["app.chdelivery.reports.defaultCategoryList"]).categoryIdAndDocsList : JSON.parse(messages["app.chdelivery.reports.defaultCategoryListForCH"]).categoryIdAndDocsList;
        break;
      default:
        categoryList = []
    }
    return categoryList;
  }

  handleClickOutside(event) {
    this.setState({...this.state,showMoreTabs: false });
  }

  setShowMoreTabs = () => {
    this.setState((state, props) => ({
      showMoreTabs: !state.showMoreTabs
    }));

  }
  onhoverEnter = ()  =>{
    this.setState({...this.state, isHoveredOnCardMenu: true})
  }
  onhoverleave = () => {
    this.setState({...this.state, isHoveredOnCardMenu: false})
  }
  
  findUnreadDocCountForOthers = (categoryList) => {
    return( categoryList.slice(REPORTS.NUMBAR_OF_FIXED_TABS)
      .filter(doc => doc.docCategoryName != REPORT_CATEGORY.ALL_DOCUMENTS)
      .reduce((sum, doc) => sum + (doc.countOfUnreadDocs || 0), 0)
    );
  }

  renderCategoryTabs = () => {
    const { i18n: { messages }, reports: { selectedCategoryTabIndex } } = this.props;
    const categoryList = this.rangeCategoryList();
    return (
      <View>
        <div className='category-container'>
          <div className='tabs-container'>
            <Tabs
              className="category-tabs"
              stretch
              secondary
              handleSelectedIndex={(index) => this.handleSelectedIndex(index, categoryList)}
              selectedIndex={selectedCategoryTabIndex} >
              {
                categoryList.slice(0,REPORTS.NUMBAR_OF_FIXED_TABS).map(item => {
                  return this.renderCategoryTab(item);
                })
              }
            </Tabs>
          </div>
          <OutsideClickNotifier  handler={this.handleClickOutside.bind(this)}>
            <div  onClick={this.setShowMoreTabs} className='more-tab-container'>

              <div onMouseEnter={this.onhoverEnter} onMouseLeave={this.onhoverleave} className='cardmenu'>
                <CardMenu  color={this.state.isHoveredOnCardMenu ? PALETTE.primaryActive : PALETTE.secondaryActive} height={24} width={24} />
              </div>
            <Badge value={this.findUnreadDocCountForOthers(categoryList)}/>  
            </div>

           { this.state.showMoreTabs && 
                <div className='variable-tabs'>
                  <Grid
                    ref={this.setRef}
                    rowCount={categoryList.length - REPORTS.NUMBAR_OF_FIXED_TABS}
                    stickyTopRowCount={categoryList.length - REPORTS.NUMBAR_OF_FIXED_TABS}
                    rowHeight={() => 52}
                    columnCount={1}
                    columnWidth={this.columnWidth}
                    renderCell={this.renderCell}
                  />
                </div>
            }
          </OutsideClickNotifier>

        </div>
      </View>
    )
  }


// /**
//  * function: renderDataExtractView will render the eDocument View
//  */
// renderDataExtractView = () => {
//   const { i18n: { messages } } = this.props;
//   return <div>
//     <Large >{messages['validation.reports.transactions.noData']}</Large>
//   </div>
// }

render() {
  return (
    <View>
      {/* {this.renderEDocumentView()}   // to be deleted  */}
      {this.renderCategoryTabs()}
      {}
    </View>
  );
}
}

ReportStatement.propTypes = {
  i18n: PropTypes.shape({
    messages: PropTypes.object,
  }),
  selectedItem: PropTypes.bool,
  detailModel: PropTypes.bool,
  loadingRow: null,
};

ReportStatement.defaultProps = {
  i18n: {},
  selectedItem: PropTypes.bool,
  detailModel: PropTypes.bool,
  loadingRow: null,
};

export default createContainer({
  $queries: {
    edelivery: {
      getUserPreferences: { $call: 'getUserPreferences' },
      showPrompt: true,
    },
    changePage: { $call: 'ui.history.push' },
    i18n: {
      messages: true,
    },
    getLastStatements: {
      $call: 'reports.getLastStatements',
    },
    setSelectedCategoryId: {
      $call: 'reports.setSelectedCategoryId'
    },
    getDocuments: {
      $call: 'reports.getDocuments',
    },
    reports: {
      showSpinner: true,
      lastMonthStatements: true,
      totalUnreadDocs: true,
      statement: {
        lastWeek: true,
        lastWeekTotalUnreadDocs: true,
        lastMonth: true,
        lastMonthTotalUnreadDocs: true,
        customRangeList: true,
        customRangeUnreadList: true,
        customRangeTotalUnreadDocs: true,
        defaultList: true,
        last90days: true,
        setLastWeek: { $set: 'lastWeek' },
        setLastMonth: { $set: 'lastMonth' },
        setlast90days: { $set: 'last90days' },
        setCustomRangeList: { $set: 'customRangeList' },
      },
      selectedCategoryId: true,
      selectedReportDetailsDateRange: true,
      selectedCategoryTabIndex: true,
      setSelectedCategoryTabIndex: {
        $set: 'selectedCategoryTabIndex'
      },
      swapCategories: { $call: 'swapCategories' }
    },
    getStatementPdf: {
      $call: 'monthly.getPdf',
    },
    dailyPdf: {
      pdf: true,
      setEmpty: { $set: 'pdf' },
    },
    resetAdvicesDates: { $call: 'advices.resetDates' },
    resetReportsDates: { $call: 'reports.resetDates' },
    portfolio: {
      netIncome: {
        value: true,
      },
    },
  },
}
)(ReportStatement);
